import { library } from '@fortawesome/fontawesome-svg-core';

import { regularBriefcaseBlankCirclePlus } from './regular-briefcase-blank-circle-plus';

export function setupCustomFaIcons() {
  library.add(regularBriefcaseBlankCirclePlus);
}
